export default __webpack_public_path__ + "static/media/1288.ce5d4ce4.jpeg";